import { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Ac2AccessGroupModel } from "src/api/access/ac-group-types";
import { getAccessGroupListAsync } from "src/api/access/productac-api";
import { useApiOperation } from "src/api/hooks";
import { PageType } from "src/api/visitor/visitor-types";
import { BaseButton } from "src/components";
import BaseSectionTitle from "src/components/layout/BaseSectionTitle";
import SpaceBaseTable from "src/pages/product/forms/commonSpaceForm/components/SpaceBaseTable";
import { useModal } from "src/recoil/modalState/hook";
import { isMobilePath } from "src/utils";
import useVisitor from "../hooks/useVisitor";
import { acGroupColumns } from "./acColumns";
import AllAccessDevicesModal from "./AllAccessDevicesModal";

/**
 * 방문자 출입그룹 조회 컴포넌트 신청계약 출입그룹에서 권한이 기본 권한일때 신청계약쪽 출입그룹을 수정불가능한 형태로 노출
 */

type Props = {
  pageType: PageType;
  contractManageId?: number;
};
const VisitorOnlyViewAccessGroup = ({ pageType, contractManageId }: Props) => {
  const { contractApplyNumber, visitApplyNumber } = useParams();

  const { setAbstractModalZ1 } = useModal();

  const location = useLocation();
  const { contractManage } = useVisitor({
    contractApplyNumber: contractApplyNumber,
    visitApplyNumber: visitApplyNumber,
  });

  // 출입그룹 목록
  const [accessGroupList, setAccessGroupList] = useState<Ac2AccessGroupModel[]>([]);

  const newColumns = useMemo(() => {
    return acGroupColumns;
  }, []);

  //출입그룹 목록 조회
  const { executeAsync: getAccessList } = useApiOperation(getAccessGroupListAsync);

  const fetchContractAccess = async () => {
    //신청계약 쪽 출입그룹을 조회
    const { data } = await getAccessList({
      contractManageId: contractManage?.contractManageId?.toString() || contractManageId?.toString(),
      visitorAccessYn: true,
    });

    setAccessGroupList(data?.data.content || []);
  };

  useEffect(() => {
    // 출입 그룹 조회
    fetchContractAccess();
  }, []);

  return (
    <article className={`contents-container__wrap-article mobile-access-table ${isMobilePath(location.pathname) ? "pb90" : ""}`}>
      <div className="">
        <div className="flex-center-between w-100">
          <BaseSectionTitle
            title={"출입그룹"}
            className=""
            noHashLink={pageType === "add"}
            rightArea={
              <div className="add-access-btn-wrap">
                <BaseButton
                  title="장치목록 한번에 보기"
                  className="color-white"
                  onClick={() =>
                    setAbstractModalZ1({
                      size: "large",
                      isOpen: true,
                      children: <AllAccessDevicesModal accessGroupIds={accessGroupList.map((group) => group.id).join(",")} />,
                    })
                  }
                />
              </div>
            }
          />
        </div>
      </div>
      <section>
        <SpaceBaseTable columns={newColumns} data={accessGroupList} baseTableTdClassName="h50" />
      </section>
    </article>
  );
};

export default VisitorOnlyViewAccessGroup;
